import React from "react";
import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

const CopyCircle = (props: SvgIconProps) => {
    const theme = useTheme();
    return (
        <SvgIcon
            {...props}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="16" cy="16" r="16" fill="white" />
            <path
                d="M10.9998 10V7C10.9998 6.44772 11.4475 6 11.9998 6H23.9998C24.5521 6 24.9998 6.44772 24.9998 7V21C24.9998 21.5523 24.5521 22 23.9998 22H20.9998V24.9991C20.9998 25.5519 20.5499 26 19.993 26H8.00666C7.45059 26 7 25.5554 7 24.9991L7.0026 11.0009C7.0027 10.4481 7.45264 10 8.00942 10H10.9998ZM9.00242 12L9.00019 24H18.9998V12H9.00242ZM12.9998 10H20.9998V20H22.9998V8H12.9998V10Z"
                fill={theme.palette.gradient!.main}
            />
        </SvgIcon>
    );
};

export default CopyCircle;
